import React, { Component } from 'react';
import { Redirect } from 'react-router'
import { inject, observer } from 'mobx-react';
import { get, post } from 'axios';
import Notifications, {notify} from 'react-notify-toast';
import {Calendar, momentLocalizer} from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css'
import momenttz from 'moment-timezone';
import "react-datepicker/dist/react-datepicker.css";
import Gravatar from 'react-gravatar';
import PerfectScrollbar from 'react-perfect-scrollbar';

const localizer = momentLocalizer(momenttz);

class BookingRow extends Component{
  constructor(props){
      super(props);
  }

  render(){
    const {booking} = this.props;
    return (
      <div className="media">
        <span className="avatar">
          <Gravatar email={booking.email} size={36} rating="pg" default="identicon"/>
        </span>
        <div className="media-body">
          <p><strong>{booking.full_name}</strong> <time className="float-right">in {booking.days_until} days</time></p>
          <p>{booking.date} - {booking.ready_time}</p>
        </div>
      </div>
    )
  }
}

@inject('userStore')
class DashboardPersonal extends Component {
    constructor(props){
        super(props);
        this.state = {
            events:[],
            height:0,
            visible:false,
            eventDate: new Date(),
            booking_list:[],
            bookingsLoaded:false
        }
    }

    componentDidMount(){
        const height = this.divElement.clientHeight;
        this.setState({ height });
        this.fetchBookings();
        // this.fetchInquiries();
        // this.fetchInvoices();
    }

    fetchBookings = () => {
      post('v2/get/bookings', {
          filter:'active'
        }, {
            auth: {username: this.props.userStore.token}
        }).then((res) => {
          res.data.event_list.forEach(function (event) {
              event.start = moment(event.start, moment.ISO_8601).toDate();
              event.end = moment(event.end, moment.ISO_8601).toDate();
          });
          this.setState({
            events:res.data.event_list,
            booking_list:res.data.booking_list,
            bookingsLoaded:true
          });
      }).catch((error) => {
          return error;
      });
    }

  render() {
    // BigCalendar.momentLocalizer(moment); // or globalizeLocalizer
    return (
        <React.Fragment>
        <Notifications />
        <div className="main-content" ref={ (divElement) => this.divElement = divElement}>
            <div className="row">
                <div className="col-md-12 col-lg-8">
                    <div className="card card-body" style={{height:this.state.height - 50 + "px"}}>
                        <Calendar
                            resizable
                            localizer={localizer}
                            events={this.state.events}
                            onSelectEvent={this.selectEvent}
                            defaultDate={new Date()}/>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4">
                    <div className="row">
                        <div className="col-lg-12">
                          <div className="card">
                              <header className="card-header">
                                <h4 className="card-title">Upcoming Bookings</h4>
                              </header>
                              <div className="card-content">
                                <PerfectScrollbar>
                                <div className="media-list media-list-divided media-list-hover">
                                {this.state.bookingsLoaded ? this.state.booking_list ? this.state.booking_list.map((booking, booking_index) => {
                                    return (<BookingRow key={booking_index} booking={booking}/>);
                                }) : <div className="badge badge-info">No Bookings right now</div>
                                : <div className="spinner-ball"></div>}
                                </div>
                                </PerfectScrollbar>
                              </div>
                          </div>
                        </div>
                    </div>
                </div>
             </div>
        </div>
        </React.Fragment>
    );
  }
}

export default DashboardPersonal;



// WEBPACK FOOTER //
// ./src/components/business/DashboardPersonal.js